import React from 'react';
import { Nav } from 'react-bootstrap';
import { useParams } from 'react-router-dom';
import IconButton from 'components/common/IconButton';
import { Trans } from 'react-i18next';
import { isAuthorized } from 'y4/Authentication';

const LoginButton = () => {
  const { corp } = useParams();
  const is_auth = isAuthorized(corp ?? 'y4');
  return !is_auth ? (
    <Nav.Item as={'li'} className="d-none d-md-block">
      <Nav.Link
        className="px-2 theme-control-toggle"
        href={`/${corp}/authentication/card/login`}
      >
        <IconButton
          className="rounded-pill me-1 mb-1"
          variant="falcon-default"
          icon="lock"
          transform="shrink-3"
        >
          <Trans ns="auth">Log in</Trans>
        </IconButton>
      </Nav.Link>
    </Nav.Item>
  ) : null;
};

export default LoginButton;
